import { render, staticRenderFns } from "./sae.vue?vue&type=template&id=3bb76863"
import script from "./sae.vue?vue&type=script&lang=js"
export * from "./sae.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports